import { ActionType, IAction } from "../actions/i-action";
import { IStore, initialState } from "../store-context";

type Handler<P = any> = (state: IStore, action: IAction<P>) => IStore;

class Reducer {
  private readonly handlersMap: Map<ActionType, Handler>;

  constructor() {
    this.handlersMap = new Map();
  }

  public createHandler = <P = any>(type: ActionType, handler: Handler<P>): Handler<P> => {
    this.handlersMap.set(type, handler);
    return handler;
  };

  public useHandler = (state: IStore = initialState, action: IAction): IStore => {
    const handler = this.handlersMap.get(action.type);
    if (handler) {
      return handler(state, action);
    }
    console.error("[Such handler was not found]: ", action.type);
    return state;
  };
}

export const reducer = new Reducer();
